"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var components_1 = require("@athena-portal/components");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../../Types");
var operators_1 = require("rxjs/operators");
var Tree_1 = require("../../../components/Tree");
var RemoveCancellationDelayAction = /** @class */ (function (_super) {
    __extends(RemoveCancellationDelayAction, _super);
    function RemoveCancellationDelayAction() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.removeCancellationDelay = function () {
            _this.props.showLoader();
            _this.supportPortalService.removeCancellationDelay(_this.props.policyNumber).pipe((0, operators_1.finalize)(function () {
                window.location.reload();
            })).subscribe();
        };
        return _this;
    }
    RemoveCancellationDelayAction.prototype.render = function () {
        if (this.props.cancellationDelayedDate) {
            return ((0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: (0, jsx_runtime_1.jsx)("a", { className: "d-block text-primary on-hover-underline", onClick: this.removeCancellationDelay, children: "Remove cancellation delay" }) }));
        }
        return null;
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], RemoveCancellationDelayAction.prototype, "supportPortalService", void 0);
    RemoveCancellationDelayAction = __decorate([
        components_1.authorize,
        (0, components_1.role)("Administrator", "CSR_Lead", "CSR")
    ], RemoveCancellationDelayAction);
    return RemoveCancellationDelayAction;
}(React.Component));
exports.default = RemoveCancellationDelayAction;
//# sourceMappingURL=RemoveCancellationDelayAction.js.map